import { apiFunction } from "../../apiCalls/function";
import * as APIs from "../../apiCalls/urls/admin/complain";

export const getMasterData = async (data) => {
  let res = await apiFunction(APIs.GET_MASTER + data, "get", {}, true, "admin");
  if (res.status) {
    return res.data;
  } else {
    return [];
  }
};

export const addTicket = async (data) => {
  return await apiFunction(APIs.ADD_COMPLAIN, "post", data, true, "admin");
};

export const addAssignee = async (data) => {
  return await apiFunction(APIs.ADD_COMPLAIN, "put", data, true, "admin");
};

export const getContactText = async (data) => {
  return await apiFunction(
    `${APIs.GET_CONTACT_TEXT}/${data.ticketId}`,
    "get",
    data,
    true,
    "admin"
  );
};

export const translateWord = async (value) => {
  return await apiFunction(
    `https://www.google.com/inputtools/request?text=${value}&ime=transliteration_en_hi&num=5&cp=0&cs=0&ie=utf-8&oe=utf-8&app=jsapi&uv=tumko&cb=_callbacks_._4lm4iimhq`,
    "get",
    {},
    false,
  );
};

// https://www.google.com/inputtools/request?text=samjhaye&ime=transliteration_en_hi&num=5&cp=0&cs=0&ie=utf-8&oe=utf-8&app=jsapi&uv=tumko%3A%E0%A4%A4%E0%A5%81%E0%A4%AE%E0%A4%95%E0%A5%8B-0-1%3A%3B0%3B0&cb=_callbacks_._4lm4iimhq
